import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import SidebarSection from './SidebarSection';
import useEntities from '../../hooks/useEntities';

const IrWorkstationSidebar = () => {
	const navigate = useNavigate();

	const {
		entities,
		loading: entitiesLoading,
		error: entitiesError,
	} = useEntities(3);

	return (
		<Box
			width={200}
			flexShrink={0}
			backgroundColor='background.paper'
			borderRight='0.5px solid'
			borderColor='border.light'
			overflow='auto'
			py='12px'
			display='flex'
			flexDirection='column'
		>
			<Box flex={1}>
				<SidebarSection label='My day'>
					<SidebarSection.Item name='Work Queue' tooltip='Coming soon!' />
					<SidebarSection.Item name='Alerts' tooltip='Coming soon!' />

					{/* SS-2816 - hiding for now
					<SidebarSection.Item
						name='Activity feed'
						badge={18}
						badgeColor='gray'
					/>
					*/}
				</SidebarSection>

				<SidebarSection label='Coverage'>
					<SidebarSection.Item name='All LPs' tooltip='Coming soon!' />

					{/* See SS-2818. We will actually implement these at a later date.

					<SidebarSection.Item name='Tier 1' badge={12} badgeColor='gray' />
					<SidebarSection.Item name='At risk' badge={2} badgeColor='red' />
					<SidebarSection.Item name='Re-up pipeline' />

					*/}
				</SidebarSection>

				<SidebarSection label='Entities'>
					{entitiesLoading ? (
						<SidebarSection.Skeleton count={3} />
					) : entitiesError ? (
						<SidebarSection.Item
							name={entitiesError}
							textColor='error.main'
							disabled
						/>
					) : entities?.length === 0 ? (
						<SidebarSection.Item name='No entities found' disabled />
					) : (
						<>
							{entities?.map((entity) => (
								<SidebarSection.Item
									key={entity.id}
									name={entity.name}
									onClick={() => navigate(`entities/${entity.id}`)}
								/>
							))}
						</>
					)}
					<SidebarSection.Item
						name='All entities'
						onClick={() => navigate('entities')}
					/>
				</SidebarSection>
			</Box>

			<Box p='12px'>
				<Button
					variant='filled'
					onClick={() => navigate('/')}
					sx={{
						width: '100%',
						height: '40px',
						backgroundColor: 'background.subtle',
						color: 'status.red.text',
						'&:hover': {
							border: '1px solid',
							borderColor: 'status.red.text',
							backgroundColor: 'status.red.bg',
						},
					}}
				>
					Back to Launchpad
				</Button>
			</Box>
		</Box>
	);
};

export default IrWorkstationSidebar;
